module.exports = __webpack_public_path__ + "13_smats_poster.pdf?b18cc6d7b6d3c1ecda3c3356bc6b7095";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperData/13_smats_poster.pdf
// module id = 135
// module chunks = 0